'use strict';

(function () {
  'use strict';

  angular.module('msUtility').service('pageTitleSvc', pageTitleSvc);

  pageTitleSvc.$inject = ['$rootScope', '$timeout', 'NotifyingSvc'];

  /* @ngInject */
  function pageTitleSvc($rootScope, $timeout, NotifyingSvc) {
    return {
      registerEventListeners: _registerEventListeners
    };

    function _registerEventListeners() {
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.PAGE_TITLE, function (event, data) {
        $timeout(function () {

          $rootScope.$state.current.data = $rootScope.$state.current.data || {};
          $rootScope.$state.current.data.pageTitle = data.pageTitle + ' | myStrength';
        });
      });
    }
  }
})();